import defaultImage from 'assets/img/avatar.png';
import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  img: {
    borderRadius: '50%'
  }
})
const Avatar = ({src, className, ...extraProps}: any) => {
  const classes = useStyles();
  const [avatar, setAvatar] = useState(defaultImage);

  useEffect(() => {
    setAvatar(src || defaultImage);
  }, [src])

  const handleError = () => {
    setAvatar(defaultImage);
  };

    return (
      <img
        alt="avatar"
        {...extraProps}
        className={`${classes.img} ${className}`}
        src={avatar || defaultImage}
        onError={handleError}
      />
    );
}

export default Avatar;